import isMobile from 'ismobilejs';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Loading from '../CircularLoading';
import LinkRequestChannelContent from './LinkRequestChannelContent';
import { fetchWhatsAppLinkAndQRCode, setWhatsAppCodeWhileLoading } from '../../actions/integrations';
import { resetLinkRequest } from '../../actions/integrations';

function LinkingView({ url, qrCode, onLinkClick }) {
    return (
        <div className="whatsapp-linking">
            <div>
                <p className="device-title">for mobile</p>
                <img alt="WhatsApp QR Code" style={{ width: '40%' }} src={qrCode} />
            </div>
            <div>
                <p className="device-title">for desktop</p>
                <a alt="Connect" target="_blank" onClick={onLinkClick} rel="noopener noreferrer" href={url}>
                    Connect
                </a>
            </div>
        </div>
    );
}

LinkingView.propTypes = {
    url: PropTypes.string.isRequired,
    qrCode: PropTypes.string.isRequired,
    onLinkClick: PropTypes.func.isRequired,
};

class WhatsAppChannelContentComponent extends Component {
    static propTypes = {
        channelState: PropTypes.object.isRequired,
        dispatch: PropTypes.func.isRequired,
        whatsappLinkingError: PropTypes.string.isRequired,
    };

    onLink = () => {
        const { dispatch } = this.props;
        dispatch(setWhatsAppCodeWhileLoading());
        dispatch(resetLinkRequest('whatsapp'));
    };

    render() {
        const { channelState, dispatch, whatsappLinkingError } = this.props;

        if (isMobile().any) {
            return <LinkRequestChannelContent type="whatsapp" channelState={channelState} />;
        }

        if (channelState.hasError) {
            return (
                <a className="error-link" onClick={() => dispatch(fetchWhatsAppLinkAndQRCode())}>
                    {whatsappLinkingError}
                </a>
            );
        }

        if (channelState.linkRequest) {
            const { url, qrCode } = channelState.linkRequest;

            return <LinkingView url={url} qrCode={qrCode} onLinkClick={this.onLink} />;
        }

        const loadingStyle = {
            height: 40,
            width: 40,
            margin: 'auto',
        };

        return <Loading dark={true} style={loadingStyle} />;
    }
}

export default connect(
    ({ ui }) => {
        return {
            whatsappLinkingError: ui.text.whatsappLinkingError,
        };
    },
    undefined,
    undefined,
    {
        forwardRef: true,
    },
)(WhatsAppChannelContentComponent);
